import React, { Fragment, useEffect } from 'react';

import { ValueBox, ValueGroup, ValueSelectInput } from '@candu-ai/craft/ui';
import { useMultiNodes } from 'craft/hooks';

interface ObjectFitProps {
  nodeIds: string[];
}

enum FitValues {
  CONTAIN = 'contain',
  COVER = 'cover',
  FILL = 'fill',
  SCALEDOWN = 'scale-down',
  NONE = 'none',
}

type Item = { value: string; label: string };
export const ObjectFit: React.FC<ObjectFitProps> = ({ nodeIds }: ObjectFitProps) => {
  const {
    css = {},
    actions: { setCss },
  } = useMultiNodes(nodeIds, (node) => {
    return {
      css: node?.data.custom.css ?? {},
    };
  });

  useEffect(() => {
    // fix console warning for unsupported style property 'object-fit'
    if (css?.['object-fit']) {
      const currentValue = css['object-fit'];
      setCss({ 'object-fit': undefined, objectFit: currentValue });
    }
  }, [nodeIds]);

  const objectFitValue = css?.objectFit || FitValues.CONTAIN;

  const updateCss = (payload: Item | null) =>
    setCss({ objectFit: payload ? payload.value : undefined });

  const items = [
    {
      value: FitValues.CONTAIN,
      label: 'Contain',
    },
    {
      value: FitValues.COVER,
      label: 'Cover',
    },
    {
      value: FitValues.FILL,
      label: 'Fill',
    },
    {
      value: FitValues.SCALEDOWN,
      label: 'Scale down',
    },
    {
      value: FitValues.NONE,
      label: 'None',
    },
  ];
  return (
    <Fragment>
      <ValueGroup>
        <ValueBox label="Fit">
          <ValueSelectInput<Item>
            scale="small"
            items={items}
            selectedItem={items.find(({ value }) => value === objectFitValue)}
            onSelect={updateCss}
          />
        </ValueBox>
      </ValueGroup>
    </Fragment>
  );
};
